// S1-SECURITY — help entries for the tenant Users invite (namespace `users`, CONTRACTS §6).
// Every claim names the code that makes it true.
import type { HelpEntry } from '../types'

export const HELP: readonly HelpEntry[] = [
  {
    id: 'users.invite',
    title: 'Invite a user',
    body: 'An invite gives a person access to the sites you choose, with the role you pick. If the address has no FuseGrid account, or its owner has not finished setting one up, FuseGrid emails that address a one-time link to finish setting up the account. If the account is already set up, the sites are added to it straight away.',
    limits: ['An invite does not make the person a tenant admin.'],
    verified_by: [
      'fusegrid_v2/server/src/admin.rs:1302',
      'fusegrid_v2/server/src/admin.rs:1629',
      'fusegrid_v2/server/src/admin.rs:1634',
      'fusegrid_v2/server/src/admin.rs:1346',
      'fusegrid_v2/src/components/parity-dev/TenantUserInviteDialog.tsx:59',
    ],
  },
  {
    id: 'users.invite_email',
    title: 'Email',
    body: 'The address of the person you are inviting. FuseGrid matches it to an existing account ignoring letter case and spaces at either end, so an address that already has an account gets the new access on that account.',
    verified_by: [
      'fusegrid_v2/server/src/auth_flow.rs:211',
      'fusegrid_v2/server/src/admin.rs:1292',
    ],
  },
  {
    id: 'users.invite_sites',
    title: 'Sites',
    body: 'Only the sites you administer are listed: the sites of every tenant where you are a tenant admin. Choose at least one, all from the same tenant. FuseGrid refuses an invite that names any other site, and then grants nothing from it, not even the sites you do administer.',
    verified_by: [
      'fusegrid_v2/server/src/admin.rs:988',
      'fusegrid_v2/server/src/admin.rs:1254',
      'fusegrid_v2/server/src/admin.rs:1274',
      'fusegrid_v2/src/components/parity-dev/TenantUserInviteDialog.tsx:41',
    ],
  },
  {
    id: 'users.invite_role',
    title: 'Role on the chosen sites',
    body: 'The role is given on every site you tick. If the person is already a member of one of those sites, their role there is replaced with this one.',
    verified_by: [
      'fusegrid_v2/server/src/admin.rs:1374',
      'fusegrid_v2/server/src/admin.rs:1386',
    ],
  },
]
